export interface AirlineInfo {
  code: string;
  name: string;
  color: string;
  colorLight: string;
  textOnColor: string;
}

export const AIRLINES: Record<string, AirlineInfo> = {
  LH: {
    code: 'LH',
    name: 'Lufthansa',
    color: '#05164d',
    colorLight: '#1a3a7a',
    textOnColor: '#ffffff',
  },
  EK: {
    code: 'EK',
    name: 'Emirates',
    color: '#d71a21',
    colorLight: '#e84249',
    textOnColor: '#ffffff',
  },
  EY: {
    code: 'EY',
    name: 'Etihad',
    color: '#bd8b2d',
    colorLight: '#d4a84a',
    textOnColor: '#ffffff',
  },
  QR: {
    code: 'QR',
    name: 'Qatar Airways',
    color: '#5c0632',
    colorLight: '#7a1a4a',
    textOnColor: '#ffffff',
  },
  TK: {
    code: 'TK',
    name: 'Turkish Airlines',
    color: '#c70a0c',
    colorLight: '#e02325',
    textOnColor: '#ffffff',
  },
  DE: {
    code: 'DE',
    name: 'Condor',
    color: '#ffcc00',
    colorLight: '#ffd633',
    textOnColor: '#1a1a1a',
  },
  BA: {
    code: 'BA',
    name: 'British Airways',
    color: '#075aaa',
    colorLight: '#1a6fcc',
    textOnColor: '#ffffff',
  },
  AF: {
    code: 'AF',
    name: 'Air France',
    color: '#002157',
    colorLight: '#0a3370',
    textOnColor: '#ffffff',
  },
  KL: {
    code: 'KL',
    name: 'KLM',
    color: '#00a1e4',
    colorLight: '#33b4ea',
    textOnColor: '#ffffff',
  },
  SQ: {
    code: 'SQ',
    name: 'Singapore Airlines',
    color: '#f0ab00',
    colorLight: '#f4be33',
    textOnColor: '#1a1a1a',
  },
  CX: {
    code: 'CX',
    name: 'Cathay Pacific',
    color: '#006564',
    colorLight: '#1a7f7e',
    textOnColor: '#ffffff',
  },
};

/** Dropdown list for airline pickers (sorted by name) */
export const AIRLINE_OPTIONS: { code: string; name: string }[] = [
  ...Object.values(AIRLINES).map((a) => ({ code: a.code, name: a.name })),
  { code: 'OTHER', name: 'Other' },
].sort((a, b) => {
  if (a.code === 'OTHER') return 1;
  if (b.code === 'OTHER') return -1;
  return a.name.localeCompare(b.name);
});

export function getAirline(code: string): AirlineInfo {
  const airline = AIRLINES[code] ?? {
    code,
    name: code,
    color: '#6b7280',
    colorLight: '#9ca3af',
    textOnColor: '#ffffff',
  };

  // In dark mode, swap to brighter colorLight for better contrast on dark backgrounds
  const isDark = typeof document !== 'undefined' && document.documentElement.classList.contains('dark');
  if (isDark) {
    return { ...airline, color: airline.colorLight };
  }
  return airline;
}

/**
 * Get the theme-appropriate airline color.
 * In dark mode, returns colorLight (brighter variant) for better contrast.
 */
export function getAirlineColor(code: string, isDark: boolean): string {
  const airline = getAirline(code);
  return isDark ? airline.colorLight : airline.color;
}
